export function setCompIdAction(list, ctx) {
  const {
    designer,
    layout
  } = ctx;
  list.push({
    title: '设置组件ID',
    desc: '设置组件ID',
    place: ['contextMenu'],
    icon: 'fa fa-edit',
    execute: async () => {
      const oldId = layout.componentId || '';
      let newVal = prompt('请输入组件的新ID', oldId);
      if (!newVal) return;
      newVal = designer.getAvailableComponentId(newVal, oldId);
      if (newVal !== oldId) {
        await designer.modifyActiveComp({
          componentId: newVal
        });
      }
    }
  });
  return list;
}
//# sourceMappingURL=setCompIdAction.js.map
